import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivAppraisalControllerFindAllParamsGen,
  MrfiktivAppraisalViewModelGen,
  MrfiktivCreateAppraisalDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateAppraisalDtoGen
} from "../v1/data-contracts";
import { Appraisal } from "../v1/Appraisal";

/**
 * Communicate with Appraisal API
 */
class AppraisalService {
  mrfiktivProxy: Appraisal;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Appraisal(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an Appraisal
   */
  async create(partnerId: string, data: MrfiktivCreateAppraisalDtoGen): Promise<MrfiktivAppraisalViewModelGen> {
    const appraisal = (await this.mrfiktivProxy.appraisalControllerCreate(partnerId, data)).data;
    return appraisal;
  }

  /**
   * Get all Appraisals
   */
  async get(
    data: MrfiktivAppraisalControllerFindAllParamsGen
  ): Promise<
    MrfiktivPageViewModelGen & {
      data?: MrfiktivAppraisalViewModelGen[];
    }
  > {
    const appraisals = (await this.mrfiktivProxy.appraisalControllerFindAll(data)).data;
    return appraisals;
  }

  /**
   * Get a single Appraisal
   */
  async getOne(partnerId: string, appraisalId: string): Promise<MrfiktivAppraisalViewModelGen> {
    const appraisal = (await this.mrfiktivProxy.appraisalControllerFindOne(partnerId, appraisalId)).data;
    return appraisal;
  }

  /**
   * Update an Appraisal
   */
  async update(
    partnerId: string,
    appraisalId: string,
    data: MrfiktivUpdateAppraisalDtoGen
  ): Promise<MrfiktivAppraisalViewModelGen> {
    const appraisal = (await this.mrfiktivProxy.appraisalControllerUpdate(partnerId, appraisalId, data)).data;
    return appraisal;
  }

  /**
   * Update Appraisal status
   */
  async updateStatus(
    partnerId: string,
    appraisalId: string,
    status: RequestStatusEnum
  ): Promise<MrfiktivAppraisalViewModelGen> {
    const appraisal = (await this.mrfiktivProxy.appraisalControllerUpdateStatus(partnerId, appraisalId, { status }))
      .data;
    return appraisal;
  }

  /**
   * Delete an Appraisal
   */
  async remove(partnerId: string, appraisalId: string) {
    (await this.mrfiktivProxy.appraisalControllerRemove(partnerId, appraisalId)).data;
  }
}

/**
 * Communicate with Appraisal API
 */
export default new AppraisalService(new MrfiktivHttpClientProvider());
